export default "__VITE_ASSET__DWnifwZi__"